import { Link } from "react-router-dom";
import "./Legal.css";

function Terminos() {
  return (
    <div className="legal-pagina">
      <Link to="/" className="legal-volver">← Volver al inicio</Link>
      <h1 className="legal-titulo">Términos de Servicio</h1>
      <p className="legal-actualizado">Última actualización: septiembre de 2026</p>

      <p>
        Al crear una cuenta y reservar turnos a través de nuestro sitio, aceptás
        estos términos. Leelos con atención.
      </p>

      <h2>Reservas de turnos</h2>
      <p>
        Los turnos se reservan a través del sitio eligiendo servicio, fecha y
        horario disponible. Atendemos de lunes a viernes de 9:00 a 19:00 hs. Los
        turnos para el mismo día (con menos de 24 horas de anticipación) o para
        los sábados se coordinan por WhatsApp y pueden tener un costo adicional.
      </p>

      <h2>Cancelaciones</h2>
      <p>
        Podés cancelar tu turno sin costo hasta 48 horas antes del horario
        reservado. Pasado ese plazo, te pedimos avisarnos por WhatsApp.
      </p>

      <h2>Precios</h2>
      <p>
        Los precios publicados son orientativos. El valor final se confirma en
        el estudio según los agregados o detalles extra que sumes el día del
        turno.
      </p>

      <h2>Tu cuenta</h2>
      <p>
        Sos responsable de mantener actualizados tus datos de contacto y de la
        confidencialidad de tu contraseña. Podés iniciar sesión con email y
        contraseña o con tu cuenta de Google.
      </p>

      <h2>Cambios en estos términos</h2>
      <p>
        Podemos actualizar estos términos ocasionalmente. Si hacemos cambios
        importantes, te lo vamos a hacer saber a través del sitio.
      </p>

      <h2>Contacto</h2>
      <p>
        Ante cualquier consulta, escribinos a{" "}
        <a href="mailto:glowroombycata@gmail.com">glowroombycata@gmail.com</a> o
        por WhatsApp al 099 481 951.
      </p>
    </div>
  );
}

export default Terminos;
